import JSvgBarProgress from './JSvgBarProgress'
export { JSvgBarProgress }
export default JSvgBarProgress